function IframeTest() {

  return <iframe title="Fexspace" src="https://app.fexspace.com/calendar/month" style={{ width: '100%', height: '100vh' }}></iframe>
}

export default IframeTest
